import { apiPost } from '../utils/api'

export const createVisitorIdentification = (email = '', firstName = '', lastName = ''): Promise => {
  const data = {
    email: email,
    firstName: firstName,
    lastName: lastName,
  }
  return apiPost('hubspot/visitor-identification', data)
}



// WEBPACK FOOTER //
// ./src/api/hubspot.js